module.exports = __webpack_public_path__ + "media/images/supporters_lp/Frame1347-60266abefea00d5758f34b14bb21b01d.png";